import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import urlUtils from 'utils/Url';

const usePageAnalytics = () => {
    const currentProduct = useSelector(state => state.page.product);
    const productRef = useRef(currentProduct);
    const preventPageRenderReport = useRef(false);
    const prevProductIdRef = useRef(currentProduct?.productDetails?.productId);

    useEffect(() => {
        const product = productRef.current;
        const skuId = urlUtils.getParamValueAsSingleString('skuId');
        const pageRenderedWithDefaultSku = !skuId;
        const pageRenderedWithNonDefaultSkuFromUrl = product?.currentSku?.skuId === skuId;

        if (!preventPageRenderReport.current && (pageRenderedWithDefaultSku || pageRenderedWithNonDefaultSkuFromUrl)) {
            preventPageRenderReport.current = true;
        }
    }, []);

    useEffect(() => {
        const newProductId = currentProduct?.productDetails?.productId;

        if (prevProductIdRef.current && newProductId && prevProductIdRef.current !== newProductId) {
            preventPageRenderReport.current = false;
        }

        prevProductIdRef.current = newProductId;
    }, [currentProduct?.productDetails?.productId]);

    return { preventPageRenderReport };
};

export default usePageAnalytics;
